module.exports = __webpack_public_path__ + "img/icon-contract-sent.7789c562.svg";